"use client"

import { Button } from "@/components/ui/button"
import { MotionDiv } from "@/components/motion"
import Image from "next/image"
import Link from "next/link"

export default function Hero() {

  return (
    <section className="relative min-h-[55vh] flex flex-col pt-[96px]">
      {/* Full-width background image — edge to edge */}
      <div className="absolute inset-0 w-full h-full">
        <Image
          src="/images/Bully Talk Hero.png"
          alt="Bully Talk speaker engaging with youth"
          fill
          className="object-cover"
          priority
        />
      </div>

      {/* White gradient overlay — solid white on far left, fades to transparent toward center */}
      <div className="absolute inset-0 z-[5] pointer-events-none"
        style={{
          background: "linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,0.85) 40%, rgba(255,255,255,0.3) 55%, rgba(255,255,255,0) 68%)"
        }}
      />

      {/* Text content on the left */}
      <div className="relative z-10 flex flex-col justify-center w-full flex-grow">
        <div className="w-full lg:w-[45%] xl:w-[42%] px-8 sm:px-12 lg:px-16 xl:px-24 py-12">
          <MotionDiv
            variants={{ hidden: { opacity: 0, x: -40 }, visible: { opacity: 1, x: 0 } }}
            className="w-full"
          >
            <h1
              className="font-antonio font-bold text-black leading-[0.9] tracking-tighter uppercase"
              style={{ fontSize: "clamp(4.5rem, 8vw, 8rem)" }}
            >
              BE THE
              <br />
              <span className="text-violet">CHANGE.</span>
              <br />
              TOGETHER.
            </h1>

            <p className="text-lg lg:text-xl text-black leading-relaxed mt-8 mb-10 max-w-sm font-normal">
              At Bully Talk Inc., we empower youth, end bullying, and build communities
              where everyone feels seen, heard, and valued.
            </p>

            <Button asChild className="bg-black text-white px-10 py-6 text-lg font-antonio font-bold rounded-none uppercase tracking-widest shadow-[6px_6px_0px_0px_#5A3290] flex items-center gap-2 transition-all hover:bg-[#5A3290] hover:-translate-y-1">
                <Link href="/about">LEARN MORE &rarr;</Link>
              </Button>
          </MotionDiv>
        </div>
      </div>

    </section>
  )
}
// trigger sync
